import { Fragment, type ReactNode, useSyncExternalStore } from 'react';
import { getDisplaySettings, subscribeDisplaySettings } from '@packages/display-policy';
import Spinners from '../components/spinner';
import useGetDisplaySettings from '../hooks/get/useGetDisplaySettings';

interface DisplaySettingsGateProps {
  enabled: boolean;
  tenantId?: string | null;
  children: ReactNode;
}

const getDecimals = (): number => getDisplaySettings().decimals;

/**
 * HTF-1482: resolves the company money display precision (2 | 4) before the app renders,
 * like BrandingProvider. No timeout: the spinner stays until the API answers.
 * No value or an error → 4, with no toast.
 */
const DisplaySettingsGate = ({ enabled, tenantId, children }: DisplaySettingsGateProps) => {
  const { isLoading } = useGetDisplaySettings(tenantId, enabled);
  // formatValue / getInputText read the store at render, so remount on change.
  const decimals = useSyncExternalStore(subscribeDisplaySettings, getDecimals);

  if (enabled && isLoading) {
    return <Spinners containerClassName='h-screen' />;
  }

  return <Fragment key={decimals}>{children}</Fragment>;
};

export default DisplaySettingsGate;
